import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { TokenService } from '@core/services/auth/token.service';
import { MensajeErrorState } from '@core/store/mensaje-error.store';
import { MensajesGenericosConstants } from '@shared/constants/mensajes-genericos-constants';
import { catchError, concatMap, EMPTY, finalize, throwError } from 'rxjs';

export const ErrorAuthInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    const tokenService = inject(TokenService);
    const mensajeErrorState = inject(MensajeErrorState);
    const router = inject(Router);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {

            if (error.status == HttpStatusCode.Unauthorized && error.error == 'Token expirado' && tokenService.getRefreshToken() != null) {
                tokenService.isRefreshing = true;

                return authService.refreshToken().pipe(
                    finalize(() => (tokenService.isRefreshing = false)),
                    concatMap((response) => {
                        if (response.access_token != null) {
                            tokenService.updateTokens(response);
                            const requestClone = tokenService.addTokenHeader(req);
                            return next(requestClone);
                        } else {
                            mensajeErrorState.actualizarMensaje(MensajesGenericosConstants.SESION_NO_VALIDA);
                            authService.onLogout();
                            router.navigateByUrl('/');
                            return EMPTY;
                        }
                    }),
                    catchError(() => {
                        mensajeErrorState.actualizarMensaje(MensajesGenericosConstants.SESION_NO_VALIDA);
                        authService.onLogout();
                        router.navigateByUrl('/');
                        return EMPTY;
                    })
                );
            }
            return throwError(() => error);
        })
    );

};
